Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    sheetMinimumPageReveal: 40,
    sheetMotionTiming: "200ms",
    sheetMotionFunction: "ease",
    sheetBackgroundColorSurface: tokens.themeSurfaceDefault,
    sheetBackgroundColorPrincipal: tokens.themePageDefault,
    sheetBackgroundColorHighlight: tokens.themePageHighlight,
    sheetBackgroundColorSubdued: tokens.themePageSubdued,
    sheetBorderWidth: 1,
    sheetBorderRadius: 0,
    sheetBorderColor: tokens.themeBorderSurface,
    sheetShadowOffsetBottomX: 0,
    sheetShadowOffsetBottomY: -8,
    sheetShadowOffsetStartX: 8,
    sheetShadowOffsetStartY: 0,
    sheetShadowOffsetEndX: -8,
    sheetShadowOffsetEndY: 0,
    sheetShadowBlur: 16,
    sheetShadowSpread: 0,
    sheetShadowColor: "#02080E",
    sheetShadowOpacity: 10
  }
};